import { render, staticRenderFns } from "./myChannels.vue?vue&type=template&id=2d1401a0&scoped=true&lang=pug"
import script from "./myChannels.vue?vue&type=script&lang=js"
export * from "./myChannels.vue?vue&type=script&lang=js"
import style0 from "./myChannels.vue?vue&type=style&index=0&id=2d1401a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1401a0",
  null
  
)

export default component.exports